import { memo, useEffect } from 'react';
import { useCopyToClipboard } from 'react-use';
import { UrlUtils } from 'src/utils';
import { IconButton } from 'src/components';
import Notify from 'src/components/notify';

const CopyButton = (props: any) => {
    const [copyState, copyFn] = useCopyToClipboard();
    const { children, link, hide, ...btnProps } = props;

    const handleClick = () => {
        copyFn(UrlUtils.buildContentLink(link));
    };

    useEffect(() => {
        if (copyState.value) {
            Notify.message({
                description: 'Copy link thành công',
                delay: 1000,
            });
            hide();
        }
    }, [copyState]);
    return (
        <IconButton
            title="Sao chép link"
            text="Sao chép link"
            icon="link"
            onClick={handleClick}
            {...btnProps}
        />
    );
};

export default memo(CopyButton);
